import PlaceholderEdge from './PlaceholderEdge';
import WorkflowEdge from './WorkflowEdge';

export const edgeTypes = {
  placeholder: PlaceholderEdge,
  workflow: WorkflowEdge,
};

export default edgeTypes;
